import { memo, useState } from 'react';
import MUIRichTextEditor, {
  TCustomControl,
  TToolbarComponentProps
} from 'mui-rte';
import { EditorState, convertToRaw } from 'draft-js';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import getCustomThemeEngine from './getCustomThemeEngine';
import { AbbottTheme } from '@abbott-components/core';
import RichTextCounterChip from './RichTextCounterChip';
import customControlList from './customControls';
import { v4 as uuidv4 } from 'uuid';

export default memo(
  ({
    initialValue,
    isReadOnly,
    handleEditorChange
  }: {
    initialValue: string;
    isReadOnly: boolean;
    handleEditorChange: (value: string) => void;
  }) => {
    const maxLimit = 10000;
    const editorId = `mui-rte-${uuidv4()}`;

    const [counter, setCounter] = useState(maxLimit);

    const defaultTheme = createTheme(AbbottTheme);

    const handleEditorChangeEvent = (state: EditorState) => {
      const currentContent = state.getCurrentContent();
      setCounter(maxLimit - currentContent.getPlainText().length);

      const rawContent = convertToRaw(currentContent);
      handleEditorChange(JSON.stringify(rawContent));
    };

    const handleEditorFocusEvent = () => {
      
        //F185246
        const x = window.scrollX;
        const y = window.scrollY;
        window.onscroll = () => { window.scrollTo(x, y) };        
        setTimeout(() => { window.onscroll = () => { /**/ } }, 200);
    };

    const customControls: TCustomControl[] = [
      ...customControlList,
      {
        name: 'charCounter',
        component: (props: TToolbarComponentProps) => (
          <RichTextCounterChip {...props} counter={counter} />
        ),
        type: 'callback',
        onClick: () => {
          return;
        }
      }
    ];

    return (
      <ThemeProvider theme={{ ...defaultTheme, ...getCustomThemeEngine() }}>
        <MUIRichTextEditor
          id={editorId}
          label="Type something here..."
          onChange={handleEditorChangeEvent}
          onFocus={handleEditorFocusEvent}
          maxLength={maxLimit}
          readOnly={isReadOnly}
          defaultValue={initialValue}
          controls={[
            'title',
            'bold',
            'italic',
            'underline',
            'highlight',
            'undo',
            'redo',
            'link',
            'numberList',
            'bulletList',
            'quote',
            'alignLeft',
            'alignCenter',
            'alignRight',
            'charCounter'
          ]}
          customControls={customControls}
        />
      </ThemeProvider>
    );
  }
);
